// auto-generated by scripts/generate-posts.js — do not edit manually
const POSTS = [
  {
    "slug": "the-worst-person-you-know",
    "title": "The worst person you know just made a great point",
    "date": "2026-05-21",
    "minutes": 5
  },
  {
    "slug": "i-gave-myself-a-year",
    "title": "I gave myself a year",
    "date": "2026-05-10",
    "minutes": 4
  }
];

export default POSTS;
